# TODO: used to display Rx maps from the Data page
exports.register = (module) ->
    module.factory 'Core.Services.MapLayers.PrescriptionMap', [
        '$injector', ($injector) ->
            return {
                new: () ->
                    service = $injector.get('Core.Services.MapLayers.Base').new()
                    # TODO: get the correct URL.. not sure if this is actually used.
                    service.url = 'backend/grower/layers/planting-rx/get-cropped-polygons'

                    return service
            }

    ]
